import React from 'react';
import { Accordion} from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import TournoisModifInscription from './tournoisModifInscription';


function TournoisAffichageInscrit(props) {


  return (
    <>
    <Accordion defaultActiveKey="0">
    {props.tournoisInscrit && props.tournoisInscrit.map((item,index) => (
                        <Accordion.Item key={index}  eventKey={index}>
                            <Accordion.Header>
                                    <div>
                                      <strong>{item.nomTournois} - {item.categorie}</strong>
                                      <hr/>
                                      Lieu : <strong>{item.localisation}</strong>
                                      <br/>
                                      Date du tournoi : <strong>{item.date}</strong>
                                      <br/>
                                      Nombres de participants : <strong>{item.nombre_participants} / {item.nbr_equipe} </strong>
                                    </div>
                            </Accordion.Header>
                            <Accordion.Body>
                            <div className="nom" style={{fontSize:"15px",fontWeight:'initial'}}>
                                           Tournois organisé par <a  href={`/coach/equipe/${item.id_equipe}`} target="_blank" rel="noopener noreferrer"><span style={{textTransform : 'capitalize'}}>{item.nom}</span></a> ({item.categorie})
                                           <br/>
                                           {item.nombre_participants === item.nbr_equipe && <strong>Tournoi Complet</strong>}
                                           <br/>
                                           Le status du tournois : {item.status}
                            </div> 
                            <br/>
                            <Form.Label>Commentaire de l'équipe organisatrice</Form.Label>
                            <Form.Control as="textarea" value={item.commentaire !== null ? (item.commentaire):('')} disabled  placeholder="Ajoutez un commentaire" rows={3} />
                            <br/>
                            <TournoisModifInscription item={item} userData={props.userData}/>
 
                                    

                        </Accordion.Body>
                        </Accordion.Item>
            ))}

    </Accordion><br/>

    </>
  );
}

export default TournoisAffichageInscrit;